<app-dialog-header titleTranslateKey="scheduler.setup.roster.confirmRun.title" (closeClicked)="cancel()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">
  <div class="confirmation-content">
    <p>Newly generated shifts will not be available until the solver is reloaded.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="confirm()" color="primary" mat-raised-button type="button">Run Now</button>
</mat-dialog-actions>